<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div>
    <b-modal
      size="xl"
      ref="lectureMessage"
      header-bg-variant="light"
      body-bg-variant="light"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <template v-slot:modal-header><h2>Tu as reçu une lettre d’un·e autre explorêveur·euse !</h2></template>
      <div class="d-flex justify-content-between align-content-center">
        <div class="container">
          <img
            src="https://cdn.exploreve.fr/content/IM3/images/paysage_carte/Interfaces/parchemin_v2-01.svg"
            class="image"
            alt="Kiwi standing on oval"
          />
          <div class="text-container">
            <div class="text">
              <p>
                Bonjour ! Je m'appelle {{ message.display_name }}, j'ai {{ message.age }} ans et et mon association d
                scoutisme c’est les {{ message.movement }}. <br />
                <br />
                Si j’étais un métier, je serais {{ message.job }}, car {{ message.job_reason }}<br />
                Si j’étais un lieu public, je serais {{ message.place }}, car {{ message.place_reason }}<br />
                Si j’étais un personnage célèbre, réel ou pas, je serais {{ message.personality }}, car
                {{ message.personality_reason }} <br />
                Ce que j’apprécie le plus chez mes amis⸱es, c’est {{ message.like_about_friends }} <br />
                Ce que je peux faire dans le scoutisme, mais pas ailleurs {{ message.scouting_activity }} <br />
                Ce que je fais quand je m’ennuie c’est {{ message.bored_activity }}. Si tu trouves que c’est une bonne
                idée, tu peux la noter ! <br />
                <br />
                Signé {{ message.display_name }}
              </p>
            </div>
          </div>
        </div>
        <!-- <div class="parchemin">
          <p>{{ local_message }}</p>
        </div> -->
      </div>
      <div class="oiseau">
        <img src="https://cdn.exploreve.fr/content/IM3/images/paysage_carte/Interfaces/perruches-01.svg" alt="" />
      </div>
      <button class="quit" @click="doneRead()">Continuer</button>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

// import * as Sentry from "@sentry/browser";
export default {
  computed: {
    ...mapGetters(["game_state"], "game_state"),
    ...mapGetters(["message"], "message"),
    ...mapGetters(["is_end"], "is_end")
  },
  methods: {
    doneRead() {
      this.$store.dispatch("changeState", "MESSAGE_READ");
    }
  },
  watch: {
    game_state: function (value) {
      if (value === "FINISHED" && this.is_end) {
        this.$refs.lectureMessage.show();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
}

.image::before {
  transform: rotate(-90deg);
}
.image {
  width: 100%;
}
.text-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: auto;
  height: 500px;
  width: 100%;
  padding-left: 190px;
  padding-right: 100px;
}
.text {
  overflow: auto;
  font-family: Faune;
  font-style: normal;
  font-weight: normal;
  font-size: 25px;
  line-height: 30px;
  color: black;
}
.h2 {
  font-family: Faune;
}
.oiseau {
  z-index: 100000;
  position: absolute;
  width: 150px;
  top: 2vh;
  left: 10vw;
}
.quit {
  background: #5e2a57;
  border-radius: 5px;
  color: white;
  font-family: Faune;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 48px;
  display: flex;
  align-items: center;
  text-align: center;
  position: absolute;
  left: 36.81%;
  right: 36.81%;
  bottom: 2.27%;
}
</style>
